import Information from "./Information";
import AliasCard from "./AliasCard";
import AliasForm from "./AliasForm";
import DeleteModal from "./DeleteModal";
import SubdomainForm from "./SudomainForm";

const privateEmailComponents = {
  Information,
  AliasCard,
  AliasForm,
  DeleteModal,
  SubdomainForm
}

export default privateEmailComponents;